import { array, object, string } from 'yup'

export const appAudienceFormSchema = () => {
  const validationShape = {
    name: string().required('Enter a name for your app').min(2, 'App name must be at least 2 characters'),
    description: string().trim().required('App description is required'),
    iconUrl: string().trim().required('App icon is required')
  } as any

  validationShape.audience = array()
    .of(
      object().shape({
        filters: array().of(
          object().shape({
            attribute: object().required().label('Attribute'),
            operator: string().required().label('Operator'),
            value: string().required().label('Value')
          })
        )
      })
    )
    .required('Audience is required')
    .min(1, 'Audience is required')

  return object().shape(validationShape)
}

export const audienceFormSchema = () => {
  const validationShape = {} as any
  validationShape.audience = array()
    .of(
      object().shape({
        filters: array().of(
          object().shape({
            attribute: object().required().label('Attribute'),
            operator: string().required().label('Operator'),
            value: string().required().label('Value')
          })
        )
      })
    )
    .required('Audience is required')
    .min(1, 'Audience is required')

  return object().shape(validationShape)
}
